export default {
  plural: 'Task members',
  timeTracked: 'Time tracked',
  muteTask: 'Mute task'
};
